var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about",staticStyle:{"background-color":"aqua","display":"flex"}},[_c('div',{staticStyle:{"width":"500px","height":"800px"},attrs:{"id":"about"}}),_c('h1',[_vm._v("This is an about page")]),_c('MindElixirDialog',{attrs:{"visible":_vm.show},on:{"update:visible":function($event){_vm.show=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }